module.exports = __webpack_public_path__ + "img/picture-placeholder.4cbbcd73.svg";